<template>
  <div class="page-table scrollable only-y">
    <div class="page-header no-table-box">
      <div class="flex justify-space-between align-center pb-15">
        <h1>
          <v-svg class="success-text" sprite="telephone" />
          Extensions
        </h1>
        <el-col class="text-right hidden-xs-only" :span="12">
          <el-tag class="mr-5">
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
          <el-tag class="mr-5">
            <status-indicator :pulse="false" status="positive" />
            Online: {{ onlineCount }}
          </el-tag>
          <el-tag>
            <status-indicator :pulse="false" status="negative" />
            Offline: {{ offlineCount }}
          </el-tag>
        </el-col>
        <!-- <el-tag class="hidden-xs-only">
          <i class="el-icon-info" style="margin-right: 4px"></i>
          Total: {{ total }}
        </el-tag> -->
      </div>
      <div class="flex pb-20">
        <div class="box">
          <el-input
            v-model="search"
            placeholder="Search"
            clearable
            class="mr-10"
            style="max-width: 193px"
          />
          <el-select
            v-model="extTypeFilter"
            @change="filterByType"
            style="max-width: 160px"
            class="hidden-xs-only"
          >
            <el-option value="all" label="All" />
            <el-option value="desk" label="Extension" />
            <el-option value="fax" label="Fax ATA" />
            <el-option value="paging" label="Paging" />
            <el-option value="sip" label="SIP trunk" />
          </el-select>
          <el-button class="ml-10 hidden-xs-only" @click="doExport">
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-dropdown>
            <el-button>
              Add New
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="openCreate('desk')">
                <v-svg class="success-text" sprite="telephone-2" />
                Extension
              </el-dropdown-item>
              <el-dropdown-item @click.native="openCreate('fax')">
                <v-svg class="voxo-orange" sprite="fax-2" />
                Fax ATA
              </el-dropdown-item>
              <el-dropdown-item @click.native="openCreate('paging')">
                <v-svg class="voxo-blue" sprite="megaphone" />
                Paging
              </el-dropdown-item>
              <el-dropdown-item @click.native="openCreate('sip')">
                <v-svg class="voxo-purple" sprite="device-cloud" />
                SIP Trunk
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            class="table-button-bulk hidden-xs-only"
            @click="bulkCreateVisible = true"
          >
            Bulk Create
          </el-button>
          <el-button
            class="table-button-bulk hidden-xs-only"
            @click="openBulkEditModal"
          >
            Bulk Edit
          </el-button>
        </div>
      </div>
      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <edit-extension-form
      :key="reRenderKeyForEdit"
      :clearFormFields="clearFormFields"
      :editProcessing="editProcessing"
      :editVisible="editVisible"
      :editExtType="editExtType"
      :numInUse="numInUse"
      :macInUse="macInUse"
      :locationsProcessing="locationsProcessing"
      :locationOptions="locationOptions"
      :branchOptions="branchOptions"
      :departmentOptions="departmentOptions"
      :numberOptions="numberOptions"
      :deviceList="deviceList"
      :faxOutboundCidOptions="faxOutboundCidOptions"
      :outboundCidNumbersOptions="outboundCidNumbersOptions"
      :deviceModelList="deviceModelList"
      :selectedExt="selectedExt"
      :musicOnHoldsList="musicOnHoldsList"
      :dncList="donotcallList"
      :outboundRecordingOptions="outboundRecordingOptions"
      @remoteFaxOutboundCid="remoteFaxOutboundCid"
      @remoteMethodForOutboundCid="remoteMethodForOutboundCid"
      @editOperation="editOperation"
      @cancelOperation="cancelOperation"
      @checkNumber="checkNumber"
      @checkMac="checkMac"
    />

    <create-extension-form
      :clearFormFields="clearFormFields"
      :createProcessing="createProcessing"
      :createVisible="createVisible"
      :createTypeHeader="createTypeHeader"
      :numInUse="numInUse"
      :macInUse="macInUse"
      :activeExtType="activeExtType"
      :locationsProcessing="locationsProcessing"
      :locationOptions="locationOptions"
      :branchOptions="branchOptions"
      :departmentOptions="departmentOptions"
      :deviceList="deviceList"
      :faxOutboundCidOptions="faxOutboundCidOptions"
      :outboundCidNumbersOptions="outboundCidNumbersOptions"
      :deviceModelList="deviceModelList"
      :dncList="donotcallList"
      @remoteFaxOutboundCid="remoteFaxOutboundCid"
      @remoteMethodForOutboundCid="remoteMethodForOutboundCid"
      @createOperation="createOperation"
      @cancelOperation="cancelOperation"
      @checkNumber="checkNumber"
      @checkMac="checkMac"
    />

    <bulk-create
      :visible="bulkCreateVisible"
      @modalClosed="bulkCreateVisible = false"
      @bulkCreateComplete="queryBranches"
    />

    <bulk-edit
      :visible="bulkEditVisible"
      :branchOptions="branchOptions"
      :departmentOptions="departmentOptions"
      :locationOptions="locationOptions"
      :dstTypes="dstTypes"
      :outboundCidNumbersOptions="outboundCidNumbersOptions"
      :faxOutboundCidOptions="faxOutboundCidOptions"
      :locationsProcessing="locationsProcessing"
      :donotcallList="donotcallList"
      :outboundRecordingOptions="outboundRecordingOptions"
      @remoteMethodForOutboundCid="remoteMethodForOutboundCid"
      @remoteFaxOutboundCid="remoteFaxOutboundCid"
      @modalClosed="bulkEditVisible = false"
      @bulkPatchComplete="queryBranches"
    />

    <el-dialog
      :visible="wireTapVisible"
      width="30%"
      :close-on-click-modal="false"
      :before-close="handleCloseWireTapModal"
      :modal="false"
    >
      <h2 class="form-section-header black-text">
        Wiretap extension {{ `${wireTapExt}` }}
      </h2>
      <p class="black-text">
        Wiretap is a feature that allows you to view a live packet capture of
        the respective extension.
      </p>
      <p class="black-text">
        You are about to be redirected to a live packet capture of this
        extension's activity. This session will die after 30 minutes. All of the
        keybindings can be found
        <a
          href="https://github.com/irontec/sngrep/wiki/Configuration#keybindings"
          target="_blank"
          >here.</a
        >
      </p>
      <p class="black-text">
        Also, if you'd like to save pcap(s) and have them emailed automatically,
        set the filename to an email address.
      </p>
      <el-button @click="startWireTap"> Start </el-button>
    </el-dialog>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapActions } from "vuex";
import { globalEventBus } from "../../../globalEventBus";
import feathersClient, {apiV2Host} from "../../../feathers/feathers-client";
import CreateExtensionForm from "./components/createForm";
import EditExtensionForm from "./components/editForm";
import BulkCreate from "./components/bulkCreate";
import BulkEdit from "./components/bulkEdit";
import { ExportToCsv } from "export-to-csv";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "ExtensionForm",
  components: { CreateExtensionForm, EditExtensionForm, BulkCreate, BulkEdit },
  data() {
    return {
      total: 0,
      onlineCount: 0,
      offlineCount: 0,
      extTypeFilter: "all",
      bulkCreateVisible: false,
      bulkEditVisible: false,
      reRenderKeyForEdit: "somethingrandom",
      extNumber: null,
      deleteProcessing: false,
      mac: null,
      clearFormFields: false,
      tableData: [],
      allExtensions: [],
      tableLoading: false,
      search: "",
      visibleActionsId: "",
      editExtensionId: "",
      editVisible: false,
      selectedExt: {},
      createVisible: false,
      typeSelector: false,
      activeExtType: "",
      editExtType: "",
      createProcessing: false,
      editProcessing: false,
      createTypeHeader: "",
      deskFieldsActive: false,
      faxFieldsActive: false,
      sipFieldsActive: false,
      locationOptions: [],
      locationsProcessing: false,
      numberOptions: [],
      outboundCidNumbersOptions: [],
      faxOutboundCidOptions: [],
      numbersProcessing: false,
      branchOptions: [],
      departmentOptions: [],
      numInUse: null,
      macInUse: null,
      deviceList: [],
      donotcallList: [],
      deviceModelList: [],
      queryForOutboundCid: "",
      faxOutboundCidQuery: "",
      musicOnHoldsList: [],
      extChannel: null,
      wireTapVisible: false,
      wireTapExt: null,
      wireTapCid: null,
      tableColumns: [
        {
          field: "avatar",
          title: "",
          width: "50",
          sortable: false,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div class="avatar-group">
                  <div class="dnd-icon" v-show={row.dnd}>
                    <hr />
                    <status-indicator></status-indicator>
                  </div>
                  {row.avatarPath ? (
                    <div class="contact-avatar">
                      <img
                        src={row.avatarPath}
                        alt={row.name}
                        title={row.name}
                      />
                    </div>
                  ) : (
                    <div class="contact-avatar">
                      {row.name.substring(0, 1).toUpperCase()}
                    </div>
                  )}
                </div>,
              ];
            },
          },
        },
        {
          field: "status",
          title: "",
          width: 45,
          slots: {
            default: ({ row }) => {
              return [
                <status-indicator
                  pulse={false}
                  status={row.onlineStatus ? "positive" : "negative"}
                />,
              ];
            },
          },
        },
        {
          field: "name",
          title: "Name",
          minWidth: "150",
          sortable: true,
          showOverflow: true,
          slots: {
            default: ({ row }) => {
              return [<span class="first-table-column">{row.name}</span>];
            },
          },
        },
        {
          field: "email",
          title: "Email",
          minWidth: 200,
          sortable: true,
          showOverflow: true,
        },
        {
          field: "number",
          title: "Number",
          minWidth: "100",
          sortable: true,
          sortType: "number",
          showOverflow: false,
        },
        {
          field: "cidNum",
          title: "Caller Id",
          minWidth: "150",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [<span>{this.numberFormatter(row.cidNum)}</span>];
            },
          },
        },
        {
          field: "phoneNumbers",
          title: "Direct Dials",
          sortable: true,
          minWidth: 150,
          showOverflow: "tooltip",
          slots: {
            default: ({ row }) => {
              return [
                <span>
                  {row.phoneNumbers
                    .map((item) => this.numberFormatter(item))
                    .join(", ")}
                </span>,
              ];
            },
          },
        },
        {
          field: "branch",
          title: "Branch",
          minWidth: "150",
          sortable: true,
          showOverflow: true,
        },
        {
          field: "actions",
          title: "",
          minWidth: "210",
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={"edit-" + row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={"delete-" + row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                  <el-tooltip placement="top" content="Reset status">
                    <el-button
                      id={"refresh-" + row.id}
                      icon="el-icon-refresh"
                      onClick={() => this.refreshStatus(row.id)}
                      class="table-action-button icon-orange"
                    />
                  </el-tooltip>
                  <el-tooltip placement="top" content="Reboot devices">
                    <el-button
                      id={"device-sync-" + row.id}
                      icon="el-icon-remove-outline"
                      onClick={() => this.refreshDevices(row.peerName)}
                      class="table-action-button icon-aqua"
                    />
                  </el-tooltip>
                  <el-tooltip placement="top" content="Wiretap">
                    <el-button
                      id={"wire-tap-" + row.id}
                      icon="el-icon-sort"
                      class="table-action-button icon-green"
                      onClick={() => this.openWireTapModal(row)}
                    />
                  </el-tooltip>
                </div>,
              ];
            },
          },
        },
      ],
      outboundRecordingOptions: [
        { label: "Yes", value: "yeschange" },
        { label: "No", value: "no" },
        { label: "No, but allow start/stop", value: "nochange" },
      ],
    };
  },
  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    },
    dstTypes() {
      return this.$store.state.destTypes;
    },
  },
  watch: {
    search: debounce(function () {
      this.searchExtensions();
    }, 500),
    // For inputting extension Number
    extNumber: debounce(function () {
      const checkNumberService = feathersClient.service("check-number");
      checkNumberService
        .find({
          query: { tenantId: this.selectedTenant.id, number: this.extNumber },
        })
        .then((res) => {
          this.numInUse = res;
        });
    }, 500),
    // For inputting mac address for newDevice
    mac: debounce(function () {
      if (this.mac) {
        const checkNumberService = feathersClient.service("check-number");
        checkNumberService
          .find({
            query: { mac: this.mac },
          })
          .then((res) => {
            this.macInUse = res;
          });
      }
    }, 500),
    // For selecting Outbound Caller Id
    queryForOutboundCid: debounce(function () {
      this.getCallerIdOptions(this.queryForOutboundCid);
    }, 500),
    // ⭐️ For Selecting Outbound Fax Caller Id ⭐️ //
    faxOutboundCidQuery: debounce(function () {
      this.queryFaxOutboundCidOptions(this.faxOutboundCidQuery);
    }, 500),

    selectedTenant() {
      this.queryExtensions();
      this.queryBranches();
      this.getDevicelist();
      this.getDonotcallList();
      this.queryNumberOptions();
      this.queryLocationOptions();
      this.getMusiconHoldsList();
      feathersClient
        .service("channel-memberships")
        .remove(null, { query: { channelName: this.extChannel } });
      this.joinSocketChannel();
    },
    user() {
      this.queryExtensions();
      this.queryBranches();
      this.getDevicelist();
      this.getDeviceModelList();
      if (!this.extChannel) {
        this.joinSocketChannel();
      }
    },

    tableData(data) {
      let onlineCount = 0;
      let offlineCount = 0;
      this.onlineCount = 0;
      this.offlineCount = 0;

      if (data) {
        for (let row of data) {
          if (row.onlineStatus) {
            onlineCount++;
            continue;
          }

          offlineCount++;
        }
      }

      this.onlineCount = onlineCount;
      this.offlineCount = offlineCount;


    },
  },
  methods: {
    getRandomKey() {
      const randomString = () => Math.random().toString(36).slice(2);
      return `${randomString()}-${randomString()}$${randomString()}`;
    },

    ...mapActions("extensions", {
      createExtensions: "create",
      deleteExtensions: "remove",
      patchExtensions: "patch",
    }),
    ...mapActions("musiconholds", { getMusicOnHolds: "find" }),

    cellClicked(data) {
      if (data.column.property !== "actions") {
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data) {
      this.visibleActionsId = data.row.id;
    },

    rowLeave() {
      this.visibleActionsId = "";
    },

    getMusiconHoldsList() {
      let params = {
        query: {
          tenantId: { $in: [0, this.selectedTenant.id] },
        },
      };
      feathersClient
        .service("musiconholds")
        .find(params)
        .then((res) => {
          this.musicOnHoldsList = [...res];
        }).catch(e => {
          this.musicOnHoldsList = [];
      });
    },

    getDevicelist() {
      this.deviceList = [];
      let params = {
        query: {
          tenantId: this.selectedTenant.id,
          phLine1ExId: { $in: [0, null] },
        },
      };
      feathersClient
        .service("devices")
        .find(params)
        .then((res) => {
          this.deviceList = [...res];
        }).catch(() => {
          this.deviceList = [];
      });
    },

    // ⭐️ Filtering Outbound Fax Caller Id ⭐️ //
    remoteFaxOutboundCid(query) {
      this.faxOutboundCidQuery = query;
    },

    // Filtering Outbound Caller Id
    remoteMethodForOutboundCid(query) {
      this.queryForOutboundCid = query;
    },

    fetchCidNums(query) {
      const didsService = feathersClient.service("dids");
      const didParams = {
        query: {
          tenantId: this.selectedTenant.id,
          allowEmergency: "",
          $limit: 10,
        },
      };

      if (query && query.length) {
        didParams.query.number = { $like: `%${query}%` };
      }

      return didsService.find(didParams);
    },

    // ⭐️ Method to get available Outbound Fax Caller Ids ⭐️ //
    queryFaxOutboundCidOptions(query) {
      this.fetchCidNums(query).then((res) => {
        this.faxOutboundCidOptions = [];
        res.forEach((t) => {
          this.faxOutboundCidOptions.push({
            key: t.id,
            label: t.number,
            disabled: false,
          });
        });
      });
    },

    // Method to get available Outbound Caller Ids
    getCallerIdOptions(query) {
      this.fetchCidNums(query).then((res) => {
        this.outboundCidNumbersOptions = [];
        res.forEach((t) => {
          this.outboundCidNumbersOptions.push({
            key: t.id,
            label: t.number,
            disabled: false,
          });
        });
      });
    },

    getDonotcallList() {
      let params = {
        query: { tenantId: this.selectedTenant.id },
      };
      feathersClient
        .service("donotcalls")
        .find(params)
        .then((res) => {
          this.donotcallList = [...res];
        }).catch((e) => {
          this.donotcallList = [];
      });
    },

    getDeviceModelList() {
      feathersClient
        .service("device-models")
        .find()
        .then((res) => {
          this.deviceModelList = [...res];
        }).catch(e => {
          this.deviceModelList = [];
      });
    },

    numberFormatter(val) {
      return phoneNumberFormatter(val);
    },

    searchExtensions() {
      this.tableLoading = true;
      if (this.search.length) {
        switch (this.extTypeFilter) {
          case "all":
            this.tableData = this.allExtensions.filter(
              ({ name, number, branch }) =>
                name.toLowerCase().includes(this.search.toLowerCase()) ||
                number.includes(this.search) ||
                (branch.toLowerCase().includes(this.search.toLowerCase())));
            break;
          case "desk":
            this.tableData = this.allExtensions.filter(
              ({ name, number, branch, rpid, trunk }) =>
                (name.toLowerCase().includes(this.search.toLowerCase()) ||
                  number.includes(this.search) ||
                  (branch.toLowerCase().includes(this.search.toLowerCase()))) &&
                this.isDesk({ rpid, trunk })
            );
            break;
          case "fax":
            this.tableData = this.allExtensions.filter(
              ({ name, number, branch, rpid, trunk }) =>
                (name.toLowerCase().includes(this.search.toLowerCase()) ||
                  number.includes(this.search) ||
                  (branch.toLowerCase().includes(this.search.toLowerCase()))) &&
                this.isFax({ rpid, trunk })
            );
            break;
          case "sip":
            this.tableData = this.allExtensions.filter(
              ({ name, number, branch, rpid, trunk }) =>
                (name.toLowerCase().includes(this.search.toLowerCase()) ||
                  number.includes(this.search) ||
                  (branch.toLowerCase().includes(this.search.toLowerCase()))) &&
                this.isSip({ rpid, trunk })
            );
            break;
          default:
            this.tableData = this.allExtensions.filter(
              ({ name, number, branch }) =>
                name.toLowerCase().includes(this.search.toLowerCase()) ||
                number.includes(this.search) ||
                (branch.toLowerCase().includes(this.search.toLowerCase())));
            break;
        }
      } else {
        this.filterByType(this.extTypeFilter);
      }
      this.tableLoading = false;
      this.total = this.tableData.length;
    },

    checkNumber(number) {
      this.extNumber = number;
    },

    checkMac(mac) {
      this.mac = mac;
    },

    clearInUseFields() {
      this.mac = "";
      this.macInUse = null;
      this.numInUse = null;
    },

    openCreate(type) {
      this.clearFormFields = false;
      this.activeExtType = type;

      if (type === "desk") {
        this.createTypeHeader = "Extension";
      } else if (type === "fax") {
        this.createTypeHeader = "Fax ATA";
      } else if (type === "paging") {
        this.createTypeHeader = "Paging";
      } else {
        this.createTypeHeader = "SIP Trunk";
      }

      this.createVisible = true;
      this.typeSelector = false;

      this.queryNumberOptions();
    },

    async queryNumberOptions() {
      const didParams = {
        query: {
          tenantId: this.selectedTenant.id,
          allowEmergency: "",
          $limit: 10,
        },
      };
      this.numbersProcessing = true;
      this.outboundCidNumbersOptions = [];
      this.faxOutboundCidOptions = [];
      this.numberOptions = [];
      feathersClient
        .service("dids")
        .find(didParams)
        .then((res) => {
          res.forEach((t) => {
            this.outboundCidNumbersOptions.push({
              key: t.id,
              label: t.number,
              disabled: false,
            });
            this.faxOutboundCidOptions = [...this.outboundCidNumbersOptions];
            if (t.useStatus === "Available") {
              this.numberOptions.push({
                key: t.id,
                label: t.number,
                disabled: false,
              });
            }
          });
          this.numbersProcessing = false;
        });
    },

    cancelOperation(edit = false) {
      if (edit) {
        this.reRenderKeyForEdit = this.getRandomKey();
      }

      // Clear the form fields
      this.selectedExt = null;
      this.clearFormFields = true;
      this.numberOptions = [];
      this.createVisible = false;
      this.editVisible = false;

      this.clearInUseFields();
    },

    createOperation(params) {
      this.createProcessing = true;
      if (params.cidNum) {
        params.cidNum = params.cidNum.replace(
          /['":;/{}()[|\-.,<>?_= \]]/g,
          ""
        );
      }
      const createBody = {
        ...params,
        tenantId: this.selectedTenant.id,
        tenantCode: this.selectedTenant.tenantCode,
      };
      // change fields based on DB field format
      this.createExtensions(createBody)
        .then((res) => {
          this.$notify({
            title: "Success",
            message: "Created successfully!",
            type: "success",
          });
          this.createProcessing = false;
          this.cancelOperation();
        })
        .catch((error) => {
          if (error.hasOwnProperty("errors")) {
            this.$notify({
              title: error.message,
              message: error.errors[Object.keys(error.errors)[0]],
              type: "error",
            });
          } else {
            this.$notify({
              title: error.name,
              message: error.message,
              type: "error",
            });
          }
          this.createProcessing = false;
          this.clearFormFields = false;
        });
    },

    editOperation(params) {
      this.$confirm("Edit extension?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.editProcessing = true;
          params.dnd = params.dnd ? "on" : "";
          if (params.cidNum) {
            params.cidNum = params.cidNum.replace(
              /['":;/{}()[|\-.,<>?_= \]]/g,
              ""
            );
          }
          const editBody = {
            ...params,
          };
          this.patchExtensions([this.editExtensionId, editBody])
            .then((res) => {
              this.reRenderKeyForEdit = this.getRandomKey();
              this.$notify({
                title: "Success",
                message: "Edited successfully!",
                type: "success",
              });
              this.editProcessing = false;

              this.cancelOperation(true);
            })
            .catch((error) => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error",
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error",
                });
              }
              this.editProcessing = false;
              this.clearFormFields = false;
            });
        })
        .catch(() => true);
    },

    deleteOperation(id) {
      this.$confirm("Delete extension?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.tableLoading = true;
          this.deleteExtensions(id)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success",
              });

              this.tableLoading = false;
            })
            .catch((error) => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error",
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error",
                });
              }
              this.tableLoading = false;
            });
        })
        .catch(() => true);
    },

    async openEditModal(id) {
      this.editExtensionId = id;
      this.clearFormFields = false;
      await this.queryNumberOptions();
      feathersClient
        .service("extensions")
        .get(id)
        .then((res) => {
          this.selectedExt = res;
          const { selectedCidNum, mailToFax } = res;

          // ⭐️ Populate selected outbouund fax caller id ⭐️ //
          if (
            mailToFax &&
            !this.faxOutboundCidOptions.find(({ key }) => key === mailToFax.id)
          ) {
            this.faxOutboundCidOptions.push({
              key: mailToFax.id,
              label: mailToFax.cidnum,
              disabled: false,
            });
          }

          // ⭐️ Populated outbound caller id ⭐️ //
          if (
            selectedCidNum &&
            !this.outboundCidNumbersOptions.find(
              ({ key }) => key === selectedCidNum.id
            )
          ) {
            this.outboundCidNumbersOptions.push({
              key: selectedCidNum.id,
              label: selectedCidNum.number,
              disabled: false,
            });
          }

          this.editExtType = res.type;
        });

      this.editVisible = true;
    },

    openBulkEditModal() {
      this.queryNumberOptions();
      this.bulkEditVisible = true;
    },

    queryExtensions() {
      this.tableLoading = true;
      feathersClient
        .service("extensions")
        .find({
          query: {
            addState: false,
            queryPhonebook: true,
            tenantId: this.selectedTenant.id,
          },
        })
        .then((res) => {
          this.tableData = [...res];
          this.allExtensions = [...res];
          this.total = res.length;
          this.tableLoading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.allExtensions = [];
          this.total = 0;
          this.tableLoading = false;
        });
    },

    queryBranches() {
      this.branchOptions = [];
      feathersClient
        .service("branches")
        .find({
          query: {
            tenantId: this.selectedTenant.id,
            $sort: { name: 1 },
          },
        })
        .then((res) => {
          this.branchOptions = [...res];
        }).catch(() => {
          this.branchOptions = [];
      });
    },

    queryLocationOptions() {
      const locationsService = feathersClient.service("locations");
      const params = {
        query: { tenantId: this.selectedTenant.id },
      };
      this.locationsProcessing = true;

      locationsService
        .find(params)
        .then((res) => {
          this.locationOptions = res;
          this.locationsProcessing = false;
        })
        .catch((err) => {
          console.log(err);
          this.locationOptions = [];
          this.locationsProcessing = false;
        });
    },

    refreshStatus(peer) {
      this.$confirm("Clear extension state?", {
        type: "warning",
      }).then(() => {
        fetch(`${apiV2Host}/admin/extensions/reset/${peer}`, {
          method: "PATCH",
          headers: {
            "Authorization": `Bearer ${this.$store.state.auth.accessToken}`
          }
        }).catch(() => true);

        // legacy stuff for clearing extension state. not sure if it still works.
        feathersClient
          .service("nats-actions-handler")
          .create({
            reqType: "resetPeerStatus",
            peerName: peer,
          }).catch(() => true);

        this.$notify({
          title: "Success",
          message: "Successfully reset extension state!",
          type: "success",
        })
      }).catch(() => true);
    },

    refreshDevices(peer) {
      feathersClient
        .service("sbc-management")
        .create({
          command: "resyncDevices",
          peerName: peer,
        })
        .then((res) => {
          console.log(res);
          this.$notify({
            title: "Success",
            message: "Successfully sent devices reset!",
            type: "success",
          });
        })
        .catch(() => {
          this.$notify({
            title: "Error",
            message: "Failed to send reset request!",
            type: "error",
          });
        });
    },

    joinSocketChannel() {
      const channelService = feathersClient.service("channel-memberships");
      const data = {
        roomType: "extensionsCRUD",
        tenantCode: this.selectedTenant.tenantCode,
        tenantId: this.selectedTenant.id,
      };
      channelService.create(data).then((res) => {
        this.extChannel = `${data.roomType}/${data.tenantId}`;
      });
    },

    removeListeners() {
      feathersClient.service("extensions").removeListener("patched");
      feathersClient.service("extensions").removeListener("created");
      feathersClient.service("extensions").removeListener("removed");
      globalEventBus.$off("appReconnected");
    },

    filterByType(val) {
      if (this.search.length) {
        this.searchExtensions();
      } else {
        switch (val) {
          case "all":
            this.tableData = [...this.allExtensions];
            break;
          case "desk":
            this.tableData = this.allExtensions.filter((item) =>
              this.isDesk(item)
            );
            break;
          case "sip":
            this.tableData = this.allExtensions.filter((item) =>
              this.isSip(item)
            );
            break;
          case "fax":
            this.tableData = this.allExtensions.filter((item) =>
              this.isFax(item)
            );
            break;
          case "paging":
            this.tableData = this.allExtensions.filter((item) =>
              this.isPaging(item)
            );
            break;
          default:
            this.tableData = [...this.allExtensions];
            break;
        }
      }
      this.total = this.tableData.length;
    },

    isSip(val) {
      const { trunk } = val;
      return trunk === "on";
    },

    isFax(val) {
      const { rpid } = val;
      return rpid === 9;
    },

    isDesk(val) {
      const deskProfiles = [0, 6, 7];
      const { rpid, trunk } = val;
      return deskProfiles.includes(rpid) && trunk === "";
    },

    isPaging(val) {
      const { rpid } = val;
      return rpid === -1;
    },

    openWireTapModal(ext) {
      const { number, cidNum } = ext;
      console.log("opening wire tap modal for number", number);
      this.wireTapExt = number;
      this.wireTapCid = cidNum;
      this.wireTapVisible = true;
    },

    startWireTap() {
      console.log("launching wire tap", this.wireTapExt);
      const expression = !this.wireTapCid
        ? `(${this.wireTapExt}-${this.selectedTenant.tenantCode})`
        : `(${this.wireTapExt}-${this.selectedTenant.tenantCode}|${this.wireTapCid})`;
      feathersClient
        .service("nats-actions-handler")
        .create({
          reqType: "startWireTap",
          expression,
        })
        .then((res) => {
          console.log(res);
          if (res === "Request Failed") {
            this.$message({
              message: "Something went wrong! Try again.",
              duration: 1000,
            });
          } else {
            const link = document.createElement("a");
            link.href = res.url;
            link.target = "_blank";
            link.click();
            link.remove();
            this.handleCloseWireTapModal();
          }
        })
        .catch(() => {
          this.$message({
            message: "Something went wrong! Try again.",
            duration: 1000,
          });
          this.$message("Something went wrong! Try again.");
        });
    },

    handleCloseWireTapModal() {
      this.wireTapExt = null;
      this.wireTapCid = null;
      this.wireTapVisible = false;
    },

    doExport() {
      const data = [...this.tableData];
      if (data.length) {
        const writeData = data.map((item) => ({
          name: item.name,
          email: item.email ? item.email : "",
          number: item.number,
          cidNum: this.numberFormatter(item.cidNum),
          phoneNumbers: item.phoneNumbers
            .map((item) => this.numberFormatter(item))
            .join(", "),
          branch: item.branch,
          prefix: item.prefix,
          recording: item.recording,
          dialTimeout: item.dialTimeout,
          unconditionalStatus: item.unconditionalStatus,
          onBusyStatus: item.onBusyStatus,
          onOfflineStatus: item.onOfflineStatus,
          onNoAnswerStatus: item.onNoAnswerStatus,
          rpid: item.rpid,
          dnd: item.dnd,
          upid: item.upid,
          dateCreation: item.dateCreation,
          muId: item.muId,
          includeInDbn: item.includeInDbn,
          includeInPb: item.includeInPb,
          onconditionStatus: item.onconditionStatus,
          regexPrefix: item.regexPrefix,
          mailbox: item.mailbox,
          peerName: item.peerName,
          trunkHost: item.trunkHost ? item.trunkHost : "",
          callLimit: item.callLimit,
          faxDirect: item.faxDirect,
          emergencyAddress: item.emergencyAddress ? item.emergencyAddress : "",
          locationAddress: item.location ? item.location.streetNum + ' ' + item.location.streetInfo + ', ' + item.location.city + ', ' + item.location.state + ' ' + item.location.postalCode : '',
          latitude: item.location ? item.location.loc.split(",")[0] : '',
          longitude: item.location ? item.location.loc.split(",")[1] : ''
        }));

        const options = {
          filename: "extensions",
          showLabels: true,
          headers: [
            "Name",
            "Email",
            "Number",
            "Caller Id Number",
            "Direct Dials",
            "Branch",
            "Prefix",
            "Recording",
            "Dial Timeout",
            "Unconditional Status",
            "On Busy Status",
            "On Offline Status",
            "On NoAnswerStatus",
            "Rpid",
            "Dnd",
            "Upid",
            "Date Creation",
            "MuId",
            "IncludeInDbn",
            "IncludeInPb",
            "Oncondition Status",
            "Regex Prefix",
            "Mailbox",
            "Peer Name",
            "Trunk Host",
            "Call Limit",
            "Fax Direct",
            "Emergency Address Id",
            "Emergency Address",
            "Latitude",
            "Longitude",
          ],
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },
  },

  beforeDestroy() {
    feathersClient
      .service("channel-memberships")
      .remove(null, { query: { channelName: this.extChannel } });
    this.removeListeners();
    this.$refs.xGrid.$destroy();
  },

  created() {
    this.getDonotcallList();
    this.queryLocationOptions();

    if (this.user) {
      this.tableLoading = true;
      this.joinSocketChannel();
      this.queryExtensions();
      this.queryBranches();
      this.getDevicelist();
      this.getDeviceModelList();
      this.getMusiconHoldsList();
    }

    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on("appReconnected", () => {
      this.joinSocketChannel();
    });

    feathersClient.service("extensions").on("patched", (data) => {
      //find the record in the table data.
      const updateIndex = this.tableData.findIndex(
        (item) => item.id === data.id
      );
      const updateAllIndex = this.allExtensions.findIndex(
        (item) => item.id === data.id
      );
      if (updateIndex >= 0) {
        const { onlineStatus } = this.tableData[updateIndex];
        this.tableData.splice(updateIndex, 1, { ...data, onlineStatus });
      }
      if (updateAllIndex >= 0) {
        const { onlineStatus } = this.allExtensions[updateAllIndex];
        this.allExtensions.splice(updateAllIndex, 1, { ...data, onlineStatus });
      }
    });

    feathersClient.service("extensions").on("created", (data) => {
      this.tableData.push(data);
      this.allExtensions.push(data);
    });

    feathersClient.service("extensions").on("removed", (data) => {
      const indexToRemove = this.tableData.findIndex(
        (item) => item.id === data.id
      );
      const indexAllToRemove = this.allExtensions.findIndex(
        (item) => item.id === data.id
      );
      if (indexToRemove >= 0) {
        this.tableData.splice(indexToRemove, 1);
      }
      if (indexAllToRemove >= 0) {
        this.allExtensions.splice(indexAllToRemove, 1);
      }
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";

.checkbox-group {
  max-width: 600px;
  margin: auto;
}

.el-tabs {
  max-width: 600px;
  margin: auto;
}

.dashboard-button-group {
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    padding-left: 10px;
  }
}

.dashboard-button {
  text-align: center;
  padding: 18px;
}

.table-button-bulk {
  margin-left: 10px;
}

.not-in-use {
  background: $voxo-pink;
}

.dnd-icon {
  right: 9px;
}
</style>
